import { margins } from '@olist/styled-system';
import styled, { css } from 'styled-components';
import { focusContainer } from '../../../utils/focusContainer.js';
import '../../../utils/opacityDisabled.js';
import { StyledButtonIcon } from '../../ButtonIcon/styles.js';

const Wrapper = styled.div(({ theme: { olist: { components: { table }, }, }, }) => css `
    border-radius: ${table.desktop.radius};
    border: ${table.desktop['border-width']} solid
      ${table.desktop['border-color']};
    overflow: auto;

    box-sizing: border-box;
    ${margins}
  `);
const StyledTable = styled.table(({ theme: { olist: { components: { table }, }, }, }) => css `
    width: 100%;

    border-collapse: collapse;
    border-radius: ${table.desktop.radius};
  `);
const TableCol = styled.col(({ width, theme: { olist: { components: { table }, }, }, }) => css `
    width: auto;
    min-width: ${table.desktop.column['min-width']};

    ${width
    ? css `
          width: ${width}px;
          min-width: ${width}px;
        `
    : ''}
  `);
const OrderButton = styled.button(({ order, theme: { olist: { components: { table }, color, borderRadius, fontFamily, }, }, }) => css `
    display: flex;
    align-items: center;
    width: 100%;
    margin: 0;

    padding: ${table.desktop.heading.padding};

    color: ${table.desktop.heading.color};
    font-family: ${fontFamily.brand};
    font-size: ${table.desktop.heading['font-size']};
    font-weight: ${table.desktop.heading['font-weight']};
    line-height: ${table.desktop.heading['line-height']};

    border: none;
    border-radius: ${borderRadius['1xsmall']};

    background-color: transparent;

    cursor: pointer;
    text-align: left;

    svg {
      margin-right: 4px;
      vertical-align: middle;

      width: 16px;
      height: 16px;
    }

    ${focusContainer({ inset: true }) ``}
    &:hover {
      background-color: ${color.neutral.softer};
    }

    ${order === 'UNORDERED'
    ? css `
          fill: ${color.neutral.soft};
          path {
            fill: ${color.neutral.soft};
          }
        `
    : ''}
  `);
const TableHead = styled.th(({ order, textAlign = 'left', theme: { olist: { components: { table }, }, }, }) => css `
    font-size: ${table.desktop.heading['font-size']};
    font-weight: ${table.desktop.heading['font-weight']};
    line-height: ${table.desktop.heading['line-height']};
    color: ${table.desktop.heading.color};

    text-align: ${textAlign};
    vertical-align: middle;

    &:last-child {
      ${OrderButton} {
        border-top-right-radius: ${table.desktop.radius};
      }
    }

    ${!order
    ? css `
          padding: ${table.desktop.heading.padding};
        `
    : ''}
  `);
const highlightBorderStyled = css `
  &::after {
    content: '';
    height: calc(100% + 1px);
    width: 3px;
    background-color: ${(props) => props.theme.olist.color.primary.base};
    position: absolute;
    left: 0;
    bottom: 0;
    top: 0;
    z-index: 1;
  }
`;
const TableCell = styled.td(({ detailedContent, highlight, isOpened, theme: { olist: { components: { table }, }, }, }) => css `
    font-size: ${table.desktop.cell['font-size']};
    font-weight: ${table.desktop.cell['font-weight']};
    line-height: ${table.desktop.cell['line-height']};
    color: ${table.desktop.cell.color};

    padding: ${table.desktop.cell.padding};

    border-top: ${table.desktop['border-width']} solid
      ${table.desktop['border-color']};
    vertical-align: middle;

    ${detailedContent
    ? css `
          padding: ${table.desktop.detailedContentCell.padding};
        `
    : ''}

    position: relative;

    ${StyledButtonIcon} {
      padding: 0;

      svg {
        transition: transform 300ms;
        transform: rotate(${isOpened ? '-180deg' : '0deg'});
      }
    }

    ${highlight ? highlightBorderStyled : ''}
  `);
const DetailedContent = styled.td(({ theme: { olist: { components: { table }, }, }, }) => css `
    padding: ${table.desktop.detailedContent.padding};
    position: relative;

    border-top: ${table.desktop['border-width']} solid
      ${table.desktop['border-color']};

    ${highlightBorderStyled}
  `);

export { DetailedContent, OrderButton, StyledTable, TableCell, TableCol, TableHead, Wrapper };
